import {
	BackendService,
	ConfigService,
	MapService,
	SearchService
}												from '../../'
import { Component }		from '@angular/core'
import {
	HistoryConfig,
	SearchResult
}												from '../../'

@Component({
  selector:			'electra-search-results',
  styleUrls:		[ './searchResults.component.scss' ],
  templateUrl:	'./searchResults.component.html'
})
export class SearchResultsComponent {
	config:		HistoryConfig
	history:	SearchResult[]

	get shadowClass(): string {
		return this.configService.mobile ? '' : 'desktop';
	}

  constructor(public backendService: BackendService, public configService: ConfigService, public mapService: MapService, private searchService: SearchService) {
		searchService.searchResultsBS.subscribe(data => { this.gotHistory(data) })
		configService.history.subscribe(data => { this.gotConfig(data) })
	}

	entryClick(entry: SearchResult) {
		this.searchService.currentResult.next(entry);
	}

	gotConfig(config: HistoryConfig) {
		this.config = config
	}

	gotHistory(history: SearchResult[]) {
		this.history = history
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/searchResults/searchResults.component.ts